import React from 'react';

// import { Parallax, ParallaxLayer } from './react-spring';

import { animated, useSpring } from '@react-spring/web'
import { Parallax, ParallaxLayer } from '@react-spring/parallax';

import './styles.css'
import ThemeContext from '../../context';
import styled from 'styled-components';
import mountainImage from '../../assets/mountainImage.jpg';
import mountainMask from '../../assets/MountainMask.png';
import clayText from '../../assets/clayText.png';
import mountainTwo from '../../assets/mountaintwo.jpg';

const Styles = styled.div`
    
    #hero {
        /* display: block; */
        background-image: url(${mountainImage});
        background-repeat: no-repeat;
        background-size: cover;
        /* z-index: -3; */
        width: 100%;
        height: 100vh;
        /* max-height: 100vh; */
        max-width: 100vw;
    }
    
    .heroItems {
        /* Mask Image */
        background-image: url(${mountainMask});
        background-size: cover;
        background-repeat: no-repeat;
        z-index: 1;
        width: 100%;
        height: 100%;
        max-width: 100vw;
        overflow: hidden;
        position: relative;
        /* text-align: center; */
    }
    
    .heroNav {
        justify-content: center;
        display: flex;
    }
    
    .heroNav a{
        color: white;
        text-decoration: none;
        font-size: 25px;
        margin: 1% 5%;
    }
    
    .heroNav a:hover {
        color: light;
    }
    
    /* FIRST AND LAST NAME HERO TEXT */
    .firstname { font-size: 23vw; font-weight: bold;}
    
    .firstname, .lastname, .title {
        padding-left: 5vw;
        position: relative;
        top: 26vh;
        color: white;
        /* mix-blend-mode: multiply;   */
        /* line-height: -500vh; */
        line-height: .8em;
        line-break: 0;
    }
    
    .p {
        margin: 0;
        padding: 0;
    }
    
    .lastname { 
        font-size: 5vw;
        /* top: 8vh; */
        /* line-height: -100px; */
        /* line-break: 0; */
        line-height: 1.2em;
        
    }
    
    .title {
        font-size: 1.5vw;
        /* top: 3vh; */
    }
    
    .name {
        margin: 0;
        padding: 0;
        /* display: block; */
        /* position: sticky; */
    }
`;

class Hero extends React.Component {

    static contextType = ThemeContext;

    render() {
        return (
            <Styles>

                <div id='hero'>
                    <Parallax pages={1.10}>
                        <ParallaxLayer sticky={{ start: 0, end: .5 }}>

                            <ParallaxLayer speed={2} factor={.1}>
                                <div class="name">
                                    <span class="firstname">CLAY</span><br></br>
                                    <span class="lastname">ASHWORTH</span><br></br>
                                    {/* <span class="title">Software Engineer - UI/UX Designer - Offroad Racer</span><br></br> */}
                                    <span class="title">SOFTWARE ENGINEER - UI/UX DESIGNER - OFFROAD RACER</span><br></br>
                                </div>
                            </ParallaxLayer>

                            <div class="heroItems">
                                <div class="heroNav">
                                    <a href='#about'>About</a><br></br>
                                    <a href='#portfolio'>Portfolio</a><br></br>
                                </div>
                            </div>

                        </ParallaxLayer>
                    </Parallax>
                </div>

            </Styles>
        )
    }
}

export default Hero;
